import React, { Component, Fragment } from 'react';
import Agreement from './Agreement';
import DebtsTable from './DebtsTable';
import Header from './Header';
import Installment from './Installment';
import PaymentsTable from './PaymentsTable';
import Term from './Term';
import PdfContainer from './PdfContainer';
import Doc from './DocService';

export default class PrintableReceipt extends Component {
    createPdf = (html) => Doc.createPdf(html);
    render() {
        const order = this.props;

        return (
            <Fragment>
                <PdfContainer createPdf={this.createPdf}>
                    <Header order={order}/>
                        <div className="card-header">
                            <div className="p-20">
                                <div className="row">
                                    <div className="col-7">
                                        <PaymentsTable payments={order.payments} />
                                        <DebtsTable debts={order.orderItems} />
                                    </div>
                                    <div className="col-5">
                                        <Term protocol={order.protocol} state={order.orderState}  />
                                    </div>
                                </div>
                            </div>
                            <footer className="bg-lightest bt-1 p-20">
                                <div className="row">
                                    <div className="col-4 offset-1 text-right">
                                        <Installment payments={order.payments} baseAmount={order.baseAmount} totalAmount={order.totalAmount} promotionalTicket={order.promotionalTicket} totalWithDiscount={order.totalWithDiscount}/>
                                    </div>
                                    <div className="col-5">
                                        <Agreement order={order}  />
                                    </div>
                                </div>
                            </footer>
                        </div>
                </PdfContainer>
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Receipt/PrintableReceipt.js